import { styled } from '@mui/material/styles';

export const StyledVideo = styled('video')(() => ({
  height: '100%',
  width: '100%',
  objectFit: 'contain',
}));
